export default [{
  'n': '中國台灣',
  's': [{
    'n': '台北',
    'c': ['台北']
  }, {
    'n': '高雄',
    'c': ['高雄']
  }, {
    'n': '基隆',
    'c': ['基隆']
  }, {
    'n': '台中',
    'c': ['台中']
  }, {
    'n': '台南',
    'c': ['台南']
  }, {
    'n': '新竹',
    'c': ['新竹']
  }, {
    'n': '嘉義',
    'c': ['嘉義']
  }, {
    'n': '宜蘭',
    'c': ['宜蘭']
  }, {
    'n': '桃園',
    'c': ['桃園']
  }, {
    'n': '苗栗',
    'c': ['苗栗']
  }, {
    'n': '彰化',
    'c': ['彰化']
  }, {
    'n': '南投',
    'c': ['南投']
  }, {
    'n': '雲林',
    'c': ['雲林']
  }, {
    'n': '屏東',
    'c': ['屏東']
  }, {
    'n': '台東',
    'c': ['台東']
  }, {
    'n': '花蓮',
    'c': ['花蓮']
  }, {
    'n': '澎湖',
    'c': ['澎湖']
  }]
}];



// WEBPACK FOOTER //
// ./src/components/DistrictPicker/area/_tw.js